<template>
  <div class="row">
    <div class="col-xl-4 col-lg-5 col-md-6">
      <user-card> </user-card>
    </div>
    <div class="col-xl-8 col-lg-7 col-md-6">
      <info/>
    </div>
  </div>
</template>
<script>
import Info from "./AboutUs/Info.vue";
import UserCard from "./AboutUs/UserCard.vue";
export default {
  components: {
    Info,
    UserCard
  },
};
</script>
<style></style>
